import { ThumbUp } from "components/icons/generated";
import Button, { ButtonProps } from "ds/components/Button";
import { isUserflowEnabled } from "shared/Analytics";
import { isSelfHostedDistribution } from "utils/distribution";

type FeedbackButtonProps = {
  id: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  onPress?: () => void;
};

const FeedbackButton = ({ id, variant = "secondary", size, onPress }: FeedbackButtonProps) => {
  const isSelfHosted = isSelfHostedDistribution();
  const isUserflowReady = isUserflowEnabled();

  if (isSelfHosted || !isUserflowReady) {
    return null;
  }

  return (
    <Button id={id} variant={variant} startIcon={ThumbUp} size={size} onPress={onPress}>
      Leave feedback
    </Button>
  );
};

export default FeedbackButton;
